module.exports = __webpack_public_path__ + "img/c81ea84.jpg";